import {Order} from '../../types';
import { isDayDelivery } from './isDayDelivery';
import { isWeekDelivery } from './isWeekDelivery';

export function hasDeliveryDate(order: Order): boolean {
    if((isDayDelivery(order) && order.deliveryDate) || isWeekDelivery(order) && order.deliveryDate) return true;
    return false;
}